import React, { useEffect, useState } from "react";
import banner from "./mangehotel.jpg";
// import logoimage from "../../images/MAAMAAS_LOGO.png";
import './menu.css'
import Icons from "./Icons";
import { Link } from "react-router-dom";
import Best from "./Best";
import './Menudata.css';
import './housemaamaas.css';
import Aboutmaamaas from "../Component/Aboutmaamaas.js";
import LeadershipCard from "../Component/LeadershipCard.js";
import Mobilebest from "./Mobilebest";
import MissionVisionCards from "../Component/MissionVisionCards";
import GalleryCards from "../Component/GalleryCards";
import axios from "axios";
import Onlyoneresturentpakage from "../Component/Onlyoneresturentpakage";
import SuperOffer from './SuperOffer';
import { IoRestaurantOutline, IoCloseCircle } from "react-icons/io5";
import { MdRestaurantMenu, MdOutlineRestaurant } from "react-icons/md";




const Menudata = ({ vendorIdFromProps }) => {
    const [showMore, setShowMore] = useState(false);
    const [showMoree, setShowMoree] = useState(false);

    const vendorId =
        vendorIdFromProps ||
        localStorage.getItem("vendorId") ||
        3; // <– default while testing

    const [bannerData, setBannerData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 480);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // 3️⃣ Fetch once on mount OR when vendorId changes
    useEffect(() => {
        if (!vendorId) return;

        const source = axios.CancelToken.source();

        (async () => {
            try {
                setLoading(true);

                const { data } = await axios.get(
                    ` https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
                    { cancelToken: source.token }                 // ⬅️ no headers now
                );

                // 🔽 massage the fields once
                setBannerData({
                    ...data,
                    companyLogo: toImageSrc(data.companyLogo),
                    companyBanner: toImageSrc(data.companyBanner),
                });
                setError("");
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error(err);
                    setError("Could not load banner details.");
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => source.cancel();
    }, [vendorId]);



    /** Turn absolute URL, relative path, or raw base‑64 into a valid <img src>. */
    const toImageSrc = (raw) => {
        if (!raw || raw.trim() === "/" || raw.trim() === "") return "/placeholder.svg";

        const clean = raw.trim();

        // If it's already a full base64 data URL
        if (clean.startsWith("data:image")) return clean;

        // If it's a regular URL
        if (/^https?:\/\//i.test(clean)) return clean;

        // If it's base64 without data URL prefix and long enough
        if (clean.length > 100) {
            const mime = clean.startsWith("iVBORw0KGgo") ? "image/png" : "image/jpeg";
            return `data:${mime};base64,${clean}`;
        }

        return "/placeholder.svg";
    };

    const data = [
        {
            image: '/images/dish1.jpg',
            text: '17+ Clients',
            icon: '⭐',
        },
        {
            image: '/images/dish2.jpg',
            text: '7+ Experience',
            icon: '⚙️',
        },
        {
            image: '/images/dish3.jpg',
            text: '60+ Subscribers',
            icon: '👥',
        },
    ];
    if (!bannerData) return null;

    const {
        companyName,
        establishedYear,
        whatsappLink,
        instagramLink,
        facebookLink,
        twitterLink,
        companyLogo,
        companyBanner,
    } = bannerData;


    /* ---------- 4️⃣ Render ---------- */
    if (loading) return <p>Loading banner…</p>;
    if (error) return <p style={{ color: "crimson" }}>{error}</p>;
    if (!bannerData) return null;
    return (
        <div>
           <div
  style={{
    height: "86vh",
    overflowY: "auto",
    scrollbarWidth: "none",
  }}
  className="home-menu-scroll"
>

                <div className=" home-menu-data">

                    <div className=" align-items-center  topticdata" >

                        <div className="text-center">

                            <div
                                style={{
                                    position: "relative",
                                    display: "inline-block",
                                    marginTop: isMobile ? "0px" : "70px",
                                    marginBottom: "20px",
                                    zIndex: "-1111"
                                }}
                            >


                                {companyBanner && (
                                    <img
                                        src={companyBanner}
                                        alt={`${companyName} banner`}
                                        style={{
                                            // width: '63vw',
                                            height: 500,
                                            borderRadius: 10,
                                            objectFit: "cover",
                                            display: "block",
                                            marginTop: "10px"
                                        }}
                                        className="home-main-banner"
                                    />
                                )}
                                {/* all the data manufacturing different formated and higly recomended coding and all the reflwcted formated  */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 24,
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        color: "#fff",
                                        textAlign: "center",
                                        textShadow: "0 1px 4px rgba(0,0,0,.6)",
                                    }}
                                >
                                    <h1
                                        style={{
                                            margin: 0,
                                            fontSize: 53,
                                            fontWeight: "bold",
                                            fontFamily: "SF Pro, sans-serif",
                                            background: "linear-gradient(90deg, red, white)",
                                            WebkitBackgroundClip: "text",
                                            // WebkitTextFillColor: "transparent",
                                        }}
                                    >
                                        {companyName}
                                    </h1>

                                    <p
                                        style={{
                                            margin: 4,
                                            fontSize: 22,
                                            fontWeight: "bold",
                                            fontFamily: "SF Pro, sans-serif",
                                            color: "#fff",
                                        }}
                                    >
                                        Since {establishedYear}
                                    </p>

                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            right: -320,
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                        }}
                                    >
                                        {/* Open Time Box */}
                                        {/* <div className="timingall">
      <div className="timebox open">Open: 09:00 AM</div>
      <div className="timebox close">Close: 10:00 PM</div>
    </div> */}
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>

                    <div className="iconbuttongroup">
                        {/* Buttons group with time */}
                        <div className="buttongroup">
                            {/* Time box */}
                            <div className="timeboxy">
                                <p>Open: 9:30 AM</p>

                            </div>
                            <div className="timebox">
                                <p>Close: 10:30 PM</p>

                            </div>

                            {/* Buttons */}
                            <button
                                onClick={() => setShowMore(!showMore)}
                                className="greenbtn"
                            >
                                {showMore ? "Show Less" : "Know More"}
                            </button>

                            <button
                                onClick={() => setShowMoree(!showMoree)}
                                className="bluebtn"
                            >
                                {showMoree ? "Hide Gallery" : "View Gallery"}
                            </button>
                        </div>

                        {/* Icon on the right */}
                        <div className="icon">
                            <Icons />
                        </div>
                    </div>










                    {showMore && (
                        <div>
                            <Aboutmaamaas />
                            <LeadershipCard />
                            <MissionVisionCards />
                        </div>
                    )}
                    {showMoree && (
                        <div>
                            <GalleryCards />
                        </div>
                    )}
                    <div style={{ marginTop: "20px" }}>
                        <Onlyoneresturentpakage />
                        {/* <SuperOffer /> */}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Menudata;
